







































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  DrivewealthWizardStep,
} from "@/shared/types";

import InvestmentAccountTypeChangeSlots from "@/shared/components/investments/drivewealth/InvestmentAccountTypeChangeSlots.vue";
import { Validator } from "vee-validate";
import * as RouteNames from "@/employee/route-names";
import * as SharedRoutes from "@/shared/route-names";

@Component({
  components: {
    InvestmentAccountTypeChangeSlots
  }
})
export default class InvestmentAccountTypeChange extends Vue {
  $validator: Validator;
  DrivewealthWizardStep = DrivewealthWizardStep;
  SharedRoutes = SharedRoutes;
  RouteNames = RouteNames;
}
